import "../../../../../styles/ComponentsStyles/Organizational/Management/Dashboard/ImportantAppearance.style.css"
import ScrollableCardTable from "../../../../Universal/ScrollableCardTable.component";
import profileImg from "../../../../../assets/Images/TestImg/profileImage.png";

const ImportantAppearance = ({ importantAppearanceData }) => {
    return (
        <div className="importantAppearanceInformationCardContainer">
            <div className="importantAppearanceHeader">
                <h3 style={{ fontSize: "1.17em", color: "#818181", fontWeight:"500" }}>Important appearance</h3>
                <p style={{ fontSize: "12px", color: "#6F944E", margin: 0 }}>{ importantAppearanceData.length } persons</p>
            </div>
            <div className="importantAppearanceList">
                <ScrollableCardTable className="importantAppearanceListContainer" thead={["Person", "Designation", "Today's appearance"]}>
                    {importantAppearanceData &&
                        importantAppearanceData.map((person, index) => {
                            return (
                                <tr
                                    key={index}
                                    className="importantAppearanceTableRow w-full flex-row align-center justify-around"
                                >
                                    {/* Person Image, Name, and ID */}
                                    <td
                                        style={{
                                            width: `calc(100%/${3})`,
                                            textAlign: "center",
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "10px",
                                        }}
                                    >
                                        <img
                                            src={person.image ||profileImg} // Default image if not provided
                                            alt={person.personName}
                                            style={{
                                                width: "2.5rem",
                                                height: "2.5rem",
                                                borderRadius: "50%",
                                                objectFit: "cover",
                                            }}
                                        />
                                        <div style={{ textAlign: "left" }}>
                                            <p>{person.personName}</p>
                                            <p style={{ fontSize: "10px", color: "#B8B8B8", margin: 0 }}>
                                               ID: {person.personId}
                                            </p>
                                        </div>
                                    </td>

                                    {/* Designation */}
                                    <td style={{ width: `calc(100%/${3})`, textAlign: "center", color:"var(--greenColor)",fontSize: "10px"}}>
                                        {person.designation}
                                    </td>

                                    {/* Appear Today Status */}
                                    <td
                                        style={{
                                            width: `calc(100%/${3})`,
                                            textAlign: "end",
                                            color: person.appearToday === "Yes" ? "var(--greenColor)" : "var(--yelloColor)", fontSize: "10px"
                                        }}
                                    >
                                        {person.appearToday}
                                    </td>
                                </tr>
                            );
                        })}
                </ScrollableCardTable>

            </div>


        </div>
    )
};

export default ImportantAppearance;
